<template>
  <div v-if="quiktip !== null">
    <!-- block -->
    <div class="block mb-5">
      <!-- Title Title -->
      <div class="form-item pt-5 d-flex">
        <label class="w-240px mr-5"><h4>Title</h4></label>
        <div class="my-n2 flex-grow-1">
          <v-text-field
            v-model="quiktip.title"
            outlined
            dense
            :error-messages="titleErrors"
          ></v-text-field>
        </div>
      </div>
      <!--Sub Title Title -->
      <div class="form-item pt-5 d-flex">
        <label class="w-240px mr-5"><h4>SubTitle</h4></label>
        <div class="my-n2 flex-grow-1">
          <v-text-field
            v-model="quiktip.sub_title"
            outlined
            dense
            :error-messages="titleErrors"
          ></v-text-field>
        </div>
      </div>
      <!-- BU -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>Bu</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <v-autocomplete
            v-model="quiktip.bu_id"
            :items="buTabs"
            placeholder="請選擇所屬BU"
            class="w-240px"
            item-text="name"
            item-value="id"
            outlined
            dense
            :error-messages="buErrors"
          >
          </v-autocomplete>
        </div>
      </div>
      <!-- 設定日期 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-3">設定日期</h4>
          <div class="h5 ink-02-medium--text mb-3">
            前台將依設定日期顯示文章的發佈日
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="quiktip.published_at"
                placeholder="請選擇日期"
                outlined
                dense
                readonly
                v-bind="attrs"
                v-on="on"
                :error-messages="dateErrors"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="quiktip.published_at"
              @input="dateMenu = false"
            ></v-date-picker>
          </v-menu>
        </div>
      </div>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="quiktip.status"></FormSwitch>
        </div>
      </div>
      <!-- Tab  -->
      <div class="form-item pt-5 d-flex">
        <label class="w-240px mr-5"><h4>文章分類</h4></label>
        <div class="my-n2 flex-grow-1">
          <v-autocomplete
            v-model="quiktip.bu_quick_tabs_id"
            class="w-240px"
            :items="tabs"
            item-text="title"
            item-value="id"
            outlined
            dense
            :error-messages="tabErrors"
          >
          </v-autocomplete>
        </div>
      </div>
      <!-- img uploader -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Cover Photo</h4>
          <div class="h5 ink-02-medium--text">
            呈現於BU Page及Overview Page <br />
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="d-flex flex-grow-1">
          <ImgUploader
            :imageUrl.sync="quiktip.cover_photo"
            dir="quiktips"></ImgUploader>
        </div>
      </div>
      <!-- img uploader -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Banner</h4>
          <div class="h5 ink-02-medium--text">
            呈現於Detail Page置頂區 <br />
            建議尺寸：1920px * 350px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="d-flex flex-grow-1">
          <ImgUploader
            :imageUrl.sync="quiktip.detail_page_banner"
            dir="quiktips"></ImgUploader>
        </div>
      </div>
      <!-- img uploader -->
      <div class="form-item d-flex px-5 py-5"
        v-if="quiktip.bu_id == 6">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Banner Mobile</h4>
          <div class="h5 ink-02-medium--text">
            呈現於Index的小圖<br />
            建議尺寸：600px * 600px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="d-flex flex-grow-1">
          <ImgUploader
            :imageUrl.sync="quiktip.banner_mobile"
            dir="quiktips"></ImgUploader>
        </div>
      </div>
      <!-- Description -->
      <div class="form-item pt-5 d-flex">
        <label class="w-240px mr-5">
          <h4>Description</h4>
          <div class="h5 ink-02-medium--text">顯示於首頁的敘述欄位</div>
        </label>
        <div class="my-n2 flex-grow-1">
          <v-textarea
            v-model="quiktip.description"
            outlined
            dense
          ></v-textarea>
        </div>
      </div>
      <!--Main Description -->
      <div class="form-item pt-5 d-flex"
        v-if="quiktip.bu_id == 6">
        <label class="w-240px mr-5">
          <h4>場景介紹</h4>
          <div class="h5 ink-02-medium--text">顯示於內頁的場景介紹</div>
        </label>
        <div class="my-n2 flex-grow-1">
          <v-textarea
            v-model="quiktip.main_content"
            outlined
            dense
          ></v-textarea>
        </div>
      </div>
    </div>
    <!-- block2 seo setting -->
    <div class="block mb-5">
      <h3 class="px-5 pt-5">SEO settings</h3>
      <!-- Title -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Title</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="quiktip.seo_title"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Description -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Description</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-textarea
            v-model="quiktip.seo_description"
            outlined
            dense
          ></v-textarea>
        </div>
      </label>
      <!-- Keyword
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Keyword</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-textarea
            v-model="quiktip.seo_keyword"
            outlined
            dense
          ></v-textarea>
        </div>
      </label>-->
      <!-- URL -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Slug</h4>
          <div class="h5 ink-02-medium--text">SLUG是唯一值,請勿建立重複資料, 格式必須是小寫英數字，並且只能包含 "-" </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="quiktip.slug"
            :placeholder="slugPlaceholder"
            :error-messages="slugErrors"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <div class="page-divider mb-5"></div>
    </div>

    <!-- block 1 -->
    <div class="block" v-if="quiktip.bu_id">
      <PageMenu :sections="sections">
        <component :is="sectionView" style="min-height: 800px;" :quiktip="quiktip"></component>
      </PageMenu>
    </div>
    <div class="page-actions">
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ImgUploader from '@/components/ImgUploader.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import Editor from '@/components/TinymceEditor.vue';
import MultiSelectWithCheckbox from '@/components/Selection/MultiSelectWithCheckbox.vue';
import PageMenu from '@/components/PageMenu.vue';
import QuiktipProducts from '@/views/D-3_Quiktips/c/D-3-1__QuiktipsCreateEdit_Info.vue';
import QuiktipDescription from '@/views/D-3_Quiktips/c/D-3-2__QuiktipsCreateEdit_Description.vue';
import FormSwitch from '@/components/FormSwitch.vue';

export default {
  components: {
    ImgUploader,
    Breadscrumbs,
    Editor,
    MultiSelectWithCheckbox,
    PageMenu,
    QuiktipProducts,
    QuiktipDescription,
    FormSwitch,
  },
  data: () => ({
    dir: 'quiktips',
    values: '',
    dateMenu: false,
    existingSlugs: [],
    slugErrors: [],
    titleErrors: [],
    buErrors: [],
    tabErrors: [],
    dateErrors: [],
    slugPlaceholder: '可讀性URL',
    sections: [
      {
        name: 'Description',
        component: 'QuiktipDescription',
      },
      {
        name: 'Recommended products',
        component: 'QuiktipProducts',
      },
    ],
  }),
  computed: {
    ...mapState(['buTabs']),
    ...mapState('QuikTip', ['quiktip', 'tabs']),
    sectionView() {
      const section = this.sections[this.$route.query.section || 0];
      return section ? section.component : 'QuiktipDescription'; // 預設為 QuiktipDescription
    },
  },
  watch: {
    async 'quiktip.bu_id'(newBuId) {
      if (newBuId) {
        try {
          // this.categories = await this.allByBu(newBuId);
          this.tabs = await this.getTabs(newBuId);
        } catch (error) {
          // console.error('Error loading tabs:', error);
        }
      }
    },
    'quiktip.slug': function (newSlug) {
      if (newSlug) {
        this.validateSlug(newSlug);
      }
    },
    'quiktip.bu_quick_tabs_id': function (newTabs) {
      if (!newTabs) {
        try {
          this.tabs = this.getTabs(''); // 或者重新抓取新的 tab 項目
        } catch (error) {
          console.error('Error loading tabs:', error);
        }
      }
    },
  },

  async created() {
    if (!this.quiktip.published_at) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
      const day = currentDate.getDate().toString().padStart(2, '0');
      this.quiktip.published_at = `${year}-${month}-${day}`;
    }

    try {
      if (this.quiktip.id) {
        this.existingSlugs = await this.checkQuiktipsSlug(this.quiktip.id);
      } else {
        this.existingSlugs = await this.checkQuiktipsSlug('');
      }
      this.getTabs(this.quiktip.bu_quick_tabs_id ?? '');
    } catch (error) {
      console.error('初始化異常:', error);
      // 顯示一個用戶友好的錯誤訊息
    }
  },
  methods: {
    ...mapActions('category', ['allByBu']),
    ...mapActions('bupage', ['setQuiktipsDetail', 'checkQuiktipsSlug']),
    ...mapActions('QuikTip', {
      getTabs: 'getTabs',
      setQuiktipsDetail: 'save',
    }),
    cancelHandler() {
      this.$router.go(-1);
    },

    validate() {
      let isValid = true;
      const errors = {};

      if (!this.quiktip.title) {
        errors.title = 'Title 為必填';
        isValid = false;
      }
      if (!this.quiktip.bu_id) {
        errors.bu = 'Bu 為必選';
        isValid = false;
      }
      if (!this.quiktip.published_at) {
        errors.date = '設定日期 為必填';
        isValid = false;
      }
      if (this.quiktip.bu_id === 6 && !this.quiktip.bu_quick_tabs_id) {
        errors.tab = 'Category 為必選';
        isValid = false;
      }
      // 如果有錯誤，設定錯誤訊息
      this.titleErrors = errors.title || [];
      this.buErrors = errors.bu || [];
      this.dateErrors = errors.date || [];
      this.tabErrors = errors.tab || [];

      return isValid;
    },
    async saveHandler() {
      this.clearErrors();
      if (this.validate()) {
        this.setQuiktipsDetail(this.quiktip).then(() => {
          this.$router.push({ name: 'QuikTip' });
        });
      }
    },

    clearErrors() {
      this.titleErrors = [];
      this.buErrors = [];
      this.dateErrors = [];
    },
    validateSlug(slug) {
      this.slugErrors = [];

      // 檢查是否為小寫格式、英數字且僅能包含 "-"
      const regex = /^[a-z0-9-]+$/;
      if (!regex.test(slug)) {
        this.slugErrors.push('Slug必須是小寫英數字，並且只能包含 "-"');
      }

      // 檢查slug是否唯一
      if (this.existingSlugs.includes(slug)) {
        this.slugErrors.push('Slug已經存在，請選擇不同的Slug');
      }

      // 確保 slug 不為空
      if (!slug) {
        this.slugErrors.push('Slug不能為空');
      }
    },
  },
};
</script>

<style lang="scss">
// v-autocomplete
.quiktips-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }
}
.no-border {
  border-bottom:none
}
</style>
